<template>
	<div class="pay-det">
		<el-card class="cartbox" shadow="never">
			<div slot="header">
				<h3>订单信息</h3>
			</div>
			<div style="width: 100%;">
				<div class="flexBetween order-top" >
					<div class="order-msg">
						<div class="order-info flex"> 
							<p style="margin-right: 20px">订单号：{{ $route.query.orderId }}</p>
							<p>下单时间：{{ orderBasic.createTime }}</p>
						</div>
						<p>订单提交成功，请尽快付款！</p>
						<p>请在24小时内完成支付，否则订单将会自动取消。</p>
						<p>如果您在支付过程中遇到任何问题，请联系客服。</p>
					</div>
					<div>
						<h4>
							<span style="color: #666;font-size: 12px;">订单金额：</span><span style="color: #ff5722; font-size: 20px; font-weight: 600">{{ orderBasic.totalAmount }} 元</span>
						</h4>
					</div>
				</div>
				<div>
          <div class="address-info"> 
            <p>收货信息：</p>
					<p style="margin-right: 18px;">{{ orderAddress.receiverName }} {{ orderAddress.receiverPhone }}</p>
					<p style="margin-right: 18px;">{{ orderAddress.provinceName }} {{ orderAddress.cityName }} {{ orderAddress.districtName }} {{ orderAddress.detailAddress }}</p>
          </div>
					<div class="goods-info">
<p>商品信息：</p>
					<p v-for="(item, index) in orderDetails" :key="index">{{ item.spuName }} x {{ item.buyNum }}；</p>
          </div>
					
				</div>
			</div>
		</el-card>
	</div>
</template>

<script >
export default {
	name: 'PayDet',
	props: {
		orderAddress: {
			type: Object,
			required: true
		},
		orderBasic: {
			type: Object,
			required: true
		},
		orderDetails: {
			type: Array,
			required: true
		}
	},
	data() {
		return {};
	}
};
</script>


<style scoped lang="less">
.pay-det  {
    margin-bottom: 20px;
    background-color: #FFFFFF;
    box-shadow: 0px 3px 7px 0px rgba(0,122,255,0.1);
    border-radius: 15px;
    h3 {
        margin: 0;
        font-weight: 400;
        font-size: 18px;
        color: #333333;
    }

    .order-top {
      width: 100%;
      margin-bottom: 20px;
        border-bottom: 1px solid #e6e6e6;
        padding-bottom: 20px;
        align-items: baseline;
    }

    .order-msg {
flex: 1;    
   color: #333;
    font-size: 14px;

    >p {
      line-height: 22px;
      color: #666;
      font-size: 12px;
    }
    }

    .order-info {
       margin-bottom: 10px;;
    }

    h4 {
      margin: 0;
    }

    .address-info {
      p {
        display: inline-block;
        line-height: 22px;
      color: #666;
      font-size: 12px;
      }
    }

     .goods-info {
      p {
         display: inline-block;
       line-height: 22px;
      color: #666;
      font-size: 12px;
      }
    }
}
</style>
